export function getLangShort() {
  return localStorage.getItem('translation') === 'kz' ? 'kk' : 'ru';
}

export function parseMaybeJson(value, fallback = {}) {
  if (!value) return fallback;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

export function pickByLang(value, fallback = '') {
  const lang = getLangShort();
  const parsed = parseMaybeJson(value, {});
  return parsed?.[lang] || fallback;
}
